import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table
} from "reactstrap";
import React, {Component, Fragment} from "react";
import {getFormFieldValue, setFormFieldValue} from "../../containers/Applications/shared/shared";
import {getData} from "../../api/doLogin";
import {EventClient} from "../../util/eventClient";
import {formatMoney} from "../Applications/shared/shared";
import {formatDate, makeDate} from "../../util/datehelpers";

export class PolicySearch extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      data: [],
      totalResults: 0,
      formData: {},
      showIndicator: false,
      page: 1,
      limit: 30,
    }
  }

  // componentDidMount() {
  //   EventClient.emit("LMS_ENTRY_EDIT", 37131);
  // }

  // shouldComponentUpdate(nextProps, nextState) {
  //   // like writing return true
  //   return this.state.formData !== nextState.data || this.state.data !== nextState.data;
  // }

  formsUpdater(evt) {
    setFormFieldValue(evt.target.id, evt.target.value, this.state['formData'], false, (data) => this.setState({formData: data}));
  }

  search(page = 1) {
    var self = this;
    const searchData = {
      q: this.state.formData['q'] || "",
      page: page,
      limit: 20
    };
    // if (this.state.formData['all']) {
      searchData['all'] = true;
    // }
    self.setState({showIndicator: true});
    getData("policies", searchData, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          self.setState({
            data: data.data.rows,
            dataLoaded: true,
            showIndicator: false,
            page: Number(data.data.page),
            totalResults: Number(data.data.results),
            limit: Number(data.data.limit)
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  needsPages() {
    return this.state.totalResults > this.state.limit;
  }

  maxPages() {
    return Math.ceil(this.state.totalResults / this.state.limit);
  }

  onSelect(leadId) {
    EventClient.emit("LMS_ENTRY_EDIT", leadId.id);
  }

  render() {
    return (
      <Card>
        <CardHeader>
          Policy Lookup
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="3">
              <FormGroup>
                {/*<Label for="psk">Search</Label>*/}
                <Input
                  placeholder={"Search criteria"}
                  type="text"
                  id="q"
                  autoFocus
                  value={getFormFieldValue(this.state.formData['q'])}
                  onChange={(evt) => this.formsUpdater(evt)}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                      this.search()
                    }
                  }}
                />
              </FormGroup>
            </Col>
            <Col xs="2">
              <Button onClick={() => this.search()}>Search</Button>
            </Col>
            {/*<Col xs="2">*/}
            {/*  <FormGroup check className="checkbox">*/}
            {/*    <Input*/}
            {/*      className="form-check-input"*/}
            {/*      type="checkbox"*/}
            {/*      id="all"*/}
            {/*      name="all"*/}
            {/*      value="1"*/}
            {/*      checked={this.state.formData['all'] || false}*/}
            {/*      onChange={(evt) => {*/}
            {/*        if (this.state.formData['all']) {*/}
            {/*          this.setState({formData: {...this.state.formData, all: false}});*/}
            {/*        } else {*/}
            {/*          this.setState({formData: {...this.state.formData, all: true}});*/}
            {/*        }*/}
            {/*      }}*/}
            {/*    />*/}
            {/*    <Label check className="form-check-label" htmlFor="checkbox1">All Matches</Label>*/}
            {/*  </FormGroup>*/}
            {/*</Col>*/}
            {this.state.showIndicator && (
              <Col xs="1">
                <div className="sk-three-bounce" style={{margin: "7px auto"}}>
                  <div className="sk-child sk-bounce1"></div>
                  <div className="sk-child sk-bounce2"></div>
                  <div className="sk-child sk-bounce3"></div>
                </div>
              </Col>
            )}

          </Row>
          {this.state.dataLoaded ? this.state.data.length > 0 ? (
            <Fragment>
              <Table responsive size="sm">
                <thead>
                <tr>
                  <th>
                    Policy Num
                    <br/>
                    Status
                  </th>
                  <th>
                    Name
                    <br/>
                    Home/Work Phone
                  </th>
                  <th>
                    Address
                    <br/>
                    &nbsp;
                  </th>
                  <th>
                    Agent Name
                    <br/>
                    Face Amount
                  </th>
                  <th>
                    Effective Date
                    <br/>
                    Paid to Date
                  </th>
                  <th>
                    Description
                    <br/>
                    Modal / Premium Amount
                  </th>
                </tr>
                </thead>
                <tbody>
                {this.state.data.map((policy, index) => {
                  // const status = getLMSStatus(policy.status);
                  return <tr key={policy.PolicyAccountNumber}>
                    <td style={{whiteSpace: "pre"}}>
                      {`${policy['PolicyAccountNumber']}`}
                      <br/>
                      {`${policy['PolicyStatusName']}`}
                    </td>
                    <td>
                      {`${policy['ParticipantFirstName']} ${policy['ParticipantLastName']}`}
                      <br/>
                      {`${policy['ParticipantHomePhone']} / ${policy['ParticipantWorkPhone']}`}
                    </td>
                    <td>
                      {`${policy['ParticipantAddress1']}`}
                      <br/>
                      {`${policy['ParticipantCity']}, ${policy['ParticipantState']} ${policy['ParticipantZip']}`}
                    </td>
                    <td>
                      {`${policy['WritingAgentName']}`}
                      <br/>
                      {`$${formatMoney(policy['PolicyFaceAmount'])}`}
                    </td>
                    <td>
                      {`${formatDate(makeDate(policy['PolicyEffectiveDate']))}`}
                      <br/>
                      {`${formatDate(makeDate(policy['PolicyPaidToDate']))}`}
                    </td>
                    <td>
                      {`${policy['ProductDescription']}`}
                      <br/>
                      {`$${formatMoney(policy['PolicyModalPremiumAmount'])} / ${policy['PolicyModal']}`}
                    </td>
                  </tr>
                })}
                </tbody>
              </Table>
              <Pagination>
                {this.needsPages() && this.state.page > 1 && (
                  <PaginationItem><PaginationLink previous onClick={(evt) => {
                    this.search(Number(this.state.page) - 1);
                  }}>Prev</PaginationLink></PaginationItem>
                )}

                {this.generatePageLinks().map((page, index) => {
                  return <PaginationItem active={page.active} key={index}>
                    <PaginationLink onClick={() => {
                      if (!page.active) {
                        this.search(page.num);
                      }
                    }}>{page.num}</PaginationLink>
                  </PaginationItem>
                })}

                {this.needsPages() && this.state.page < this.maxPages() && (
                  <PaginationItem><PaginationLink next onClick={(evt) => {
                    this.search(Number(this.state.page) + 1);
                  }}>Next</PaginationLink></PaginationItem>
                )}
              </Pagination>
            </Fragment>
          ) : (
            <div>No results try your request again with different parameters</div>
          ) : (
            <div>Enter your search criteria above to search for user</div>
          )}
        </CardBody>
      </Card>
    );
  }

  generatePageLinks() {
    const pages = [];
    let maxPages = this.maxPages();
    if (maxPages > 15) {
      maxPages = 16
    }
    for (let pageNum = 0; pageNum < maxPages; pageNum++) {
      pages.push({
        num: pageNum + 1,
        active: pageNum + 1 === Number(this.state.page)
      });
    }
    return pages;
  }
}



// WEBPACK FOOTER //
// ./src/containers/Leads/PolicySearch.js